export default "/kiban/_next/static/images/yellow-9c16918ab71a8e19e32df805ccd8932b.png";